import type { IconSvgObject } from './types';

const Angle01Icon: IconSvgObject = [
  ["path", { d: "M21.0003 20H3L17.9252 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 20C11 17.3517 9.77371 15.0655 8 14", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Angle01Icon;
